var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-subtitle",class:{
    'text-uppercase': _vm.uppercase,
    'text--title-white': _vm.white,
    'text--title-error': _vm.error,
    'text--color--primary': _vm.color === 'primary',
    'text--color--secondary': _vm.color === 'secondary',
  }})}
var staticRenderFns = []

export { render, staticRenderFns }